type Props = {
  text: string;
};

const Text = ({ text }: Props) => {
  return <p className="mt-16 mb-0">{text}</p>;
};

export default Text;
